import storage from '@/storage';

export default (event, app) => {
  const currentTabId = app.$store.getters['ui/tabId'];
  const repeatedFrom = storage.repeatedFromTabId();

  if (currentTabId === repeatedFrom) {
    console.log('Order repeated from current tab, skipping.');

    return;
  }

  console.log(`Order repeated from other tab (${repeatedFrom}, current: ${currentTabId}), notifying customer.`);

  app.$store.commit('store/setBroadcastMessage', {
    id: `OrderRepeated:${repeatedFrom}`,
    type: { id: 'modal' },
    header: 'Заказ был изменён',
    message: `Заказ был изменён в другом окне этого браузера. Закройте эту страницу или перезагрузите её для обновления данных.`,
    immediate: true,
    action: {
      button: 'Перезагрузить страницу',
      handler() {
        location.reload();
      },
    },
  });
}
